const HISTORICS_VALUE_TYPE = {
    TEXT: { name: 'TEXT' },
    DATE: { name: 'DATE' },
    BADGE: { name: 'BADGE' },
    LIST: { name: 'LIST' },
    MULTI_VALUES: { name: 'MULTI_VALUES' }
};

export default HISTORICS_VALUE_TYPE;